"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _lunaIconSprite = require("../luna-icon-sprite");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaIcon = _react["default"].forwardRef(function (props, ref) {
  var namespace = (0, _react.useContext)(_lunaIconSprite.LunaIconSpriteContext);
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var namespace = _ref.namespace;
      return !_lodash["default"].isString(namespace) && !namespace;
    },
    message: 'Use of <LunaIcon /> outside of <LunaIconSpriteProvider> is not supported. Please see the documentation for usage.',
    breakingVersion: 100
  }], _objectSpread(_objectSpread({}, props), {}, {
    namespace: namespace
  }));
  namespace = namespace || '';
  var glyph = props.glyph,
      size = props.size,
      color = props.color,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      other = props.other;
  var base = _config.classes.base,
      sizes = _config.classes.sizes,
      colors = _config.classes.colors;

  var getClassList = function getClassList() {
    var _objectSpread2;

    return (0, _classnames["default"])(className, _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, base, true), _defineProperty(_objectSpread2, sizes[_config.LunaIconSizes.s10], size === _config.LunaIconSizes.s10), _defineProperty(_objectSpread2, sizes[_config.LunaIconSizes.s20], size === _config.LunaIconSizes.s20), _defineProperty(_objectSpread2, sizes[_config.LunaIconSizes.s30], size === _config.LunaIconSizes.s30), _defineProperty(_objectSpread2, sizes[_config.LunaIconSizes.s40], size === _config.LunaIconSizes.s40), _objectSpread2), _lodash["default"].reduce(_config.LunaIconColors, function (acc, colorClassKey) {
      acc[colors[colorClassKey]] = color === colorClassKey;
      return acc;
    }, {})));
  };

  var getLunaIconProps = function getLunaIconProps() {
    var LunaIconProps = {};
    return LunaIconProps;
  };

  return _react["default"].createElement("i", _extends({}, getLunaIconProps(), other, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }), _react["default"].createElement("svg", null, _react["default"].createElement("use", {
    xlinkHref: "#".concat(namespace, "luna-icon-").concat(glyph)
  })));
});

LunaIcon.displayName = 'LunaIcon';
LunaIcon.propTypes = {
  glyph: _propTypes["default"].oneOf(Object.values(_config.LunaGlyphs)).isRequired,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaIconSizes)),
  color: _propTypes["default"].oneOf(Object.values(_config.LunaIconColors)),
  className: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
LunaIcon.defaultProps = {
  className: '',
  other: {}
};
var _default = LunaIcon;
exports["default"] = _default;
